import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAdminStore = create(
  persist(
    (set) => ({
      token: null,
      email: null,
      isAuthenticated: false,
      
      login: (token, email) => set({ 
        token, 
        email, 
        isAuthenticated: true 
      }),
      
      logout: () => set({ 
        token: null, 
        email: null, 
        isAuthenticated: false 
      })
    }),
    {
      name: 'admin-storage'
    }
  )
);
